const createQueryString = (filters) => {
  let queryString = '?';

  queryString = Object.entries(filters)
    .reduce((res, filter) =>
      filter[1].reduce((innerRes, id) =>
        `${innerRes}${filter[0]}=${id}&`, res),
      queryString);

  queryString = queryString.slice(0, -1);

  return queryString;
};

export default createQueryString;



// WEBPACK FOOTER //
// ./src/utils/createQueryString.js